// Transaction Filtering
jq('#transactions-filter-form select').on('change', function() {
    jq('#transactions-filter-form').submit();
    return;
});

//Team Filtering
jq('#team-filter-form select').on('change', function() {
    jq('#team-filter-form').submit();
    return;
});

// Conference Filtering
jq('#conference-filter-form select').on('change', function() {
    jq('#conference-filter-form').submit();
    return;
});

// Hover Sectors
jq('.section-hover-sectors .sector-block').on('mouseover', function() {
    jq('.section-hover-sectors .sector-block').removeClass('hover');
    jq(this).addClass('hover');
});
jq('.section-hover-blocks .hover-block').on('mouseover', function() {
    jq('.section-hover-blocks .hover-block').removeClass('hover');
    jq(this).addClass('hover');
});